import React from 'react'

function Heading({ text, className, size, style, secText }) {

    return (
        <div className='cge-heading'>
            {text && size === "1" &&
                <h2 className={className} style={style}>{text}{secText}</h2>
            }
            {text && size === "2" &&
                <h3 className={className} style={style}>{text}{secText}</h3>
            }
            {text && size === "3" &&
                <h4 className={className} style={style}>{text}{secText}</h4>
            }
            {text && size === "4" &&
                <h5 className={className} style={style}>{text}{secText}</h5>
            }
        </div>

    )
}

export default Heading;